import { render, staticRenderFns } from "./DadosPedido.vue?vue&type=template&id=88267b34"
import script from "./DadosPedido.vue?vue&type=script&lang=js"
export * from "./DadosPedido.vue?vue&type=script&lang=js"
import style0 from "./DadosPedido.vue?vue&type=style&index=0&id=88267b34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports